/**
 * 업로드 허용 형식 — 서버 `upload.controller.ts` 와 **같은 값을 유지해야 한다.**
 *
 * 이 파일이 생긴 이유: 클라이언트 `accept` 와 서버 화이트리스트가 따로 놀았다.
 *  - 썸네일 입력은 `accept="image/*"` 라 HEIC 를 고를 수 있었는데 서버가 거부했다
 *    → 사용자 입장에서는 "jpg 만 올라간다"로 보였다
 *  - 사례 참조 첨부는 `.jpeg` 만 있고 `.jpg` 가 빠져 있었다
 *  - 매뉴얼 입력은 `.html` 을 받았는데 서버는 (저장형 XSS 때문에) 더 이상 받지 않는다
 *
 * 한쪽만 고치면 같은 문제가 반복되므로 목록을 한 곳에 둔다.
 */

/** 브라우저가 직접 렌더하는 이미지 */
export const WEB_IMAGE_EXT = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif'];

/** 업로드는 받되 서버가 WebP 로 변환하는 이미지 (아이폰 HEIC 등) */
export const CONVERT_IMAGE_EXT = ['heic', 'heif', 'tif', 'tiff', 'bmp'];

export const IMAGE_EXT = [...WEB_IMAGE_EXT, ...CONVERT_IMAGE_EXT];

/** 문서. `html` 은 없다 — 업로드물은 /uploads 에서 같은 오리진으로 서빙되어 저장형 XSS 통로가 된다. */
export const DOC_EXT = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv'];

const toAccept = (exts) => exts.map((e) => `.${e}`).join(',');

export const ACCEPT_IMAGE = toAccept(IMAGE_EXT);
export const ACCEPT_DOC = toAccept(DOC_EXT);
export const ACCEPT_AI_REFERENCE = toAccept([...DOC_EXT, ...IMAGE_EXT]);
/** 매뉴얼·제안서 첨부 */
export const ACCEPT_PDF = '.pdf';

/** 입력 아래에 그대로 쓸 안내 문구 */
export const IMAGE_HINT =
    `JPG · PNG · WEBP · AVIF · GIF 지원. ` +
    `아이폰 사진(HEIC)과 TIFF · BMP 도 올리면 자동으로 WEBP 로 변환합니다. 최대 50MB.`;

export const AI_REFERENCE_HINT =
    `PDF · PPTX · DOCX · XLSX · 이미지(HEIC 포함) · TXT · CSV. 최대 50MB.`;

export const PDF_HINT = 'PDF 파일만 올릴 수 있습니다. 최대 50MB.';
